export const SMS_SINGLE_MESSAGE_LIMITS = {
  english: 160,
  arabic: 70,
  emoji: 70,
};

const ARABIC_CHARACTER_REGEX = /[\u0600-\u06FF]/;
const EMOJI_CHARACTER_REGEX =
  /[\u00a9\u00ae\u203c-\u3299]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\udd00-\udfff]/;
const APPENDED_DOMAIN_PREFIX_LENGTH = 4;

export const hasArabicCharacters = (content = "") =>
  ARABIC_CHARACTER_REGEX.test(content);

export const hasEmojiCharacters = (content = "") =>
  EMOJI_CHARACTER_REGEX.test(content);

export const getSmsSingleMessageLimit = (content = "") => {
  if (hasEmojiCharacters(content)) return SMS_SINGLE_MESSAGE_LIMITS.emoji;
  if (hasArabicCharacters(content)) return SMS_SINGLE_MESSAGE_LIMITS.arabic;
  return SMS_SINGLE_MESSAGE_LIMITS.english;
};

export const getSmsAppendedDomainLength = (
  content = "",
  senderId,
  hostname = ""
) => {
  if (senderId !== "ORDABLE" || !hostname || content.includes(hostname))
    return 0;
  return APPENDED_DOMAIN_PREFIX_LENGTH + hostname.length;
};

export const getSmsContentLength = (
  content = "",
  senderId,
  hostname = ""
) =>
  content.length + getSmsAppendedDomainLength(content, senderId, hostname);

export const getSmsSegmentCount = (
  content = "",
  senderId,
  hostname = ""
) => {
  const messageLength = getSmsContentLength(content, senderId, hostname);
  if (!messageLength) return 0;
  return Math.ceil(messageLength / getSmsSingleMessageLimit(content));
};
